import { useEffect } from "react";

// ---------- Reusable check: DevTools khula hai ya nahi ----------
export const isDevToolsOpen = () => {
  const threshold = 250; // zyada margin, zoom variance handle karne ke liye
  const zoom = window.devicePixelRatio || 1;

  const widthDiff = (window.outerWidth - window.innerWidth) / zoom;
  const heightDiff = (window.outerHeight - window.innerHeight) / zoom;

  // Docked DevTools check (zoom-adjusted)
  if (widthDiff > threshold || heightDiff > threshold) {
    return true;
  }

  // Undocked DevTools check (debugger timing trick)
  const start = performance.now();
  // eslint-disable-next-line no-debugger
  debugger;
  const end = performance.now();

  return end - start > 100;
};

// ---------- Editor / contenteditable regions ko skip karne ke liye ----------
// Apne project ke actual editor wrapper classes yahan add karo
const EDITOR_SELECTORS =
  ".ck-editor, .ck-content, [contenteditable='true'], input, textarea, select";

const isInsideEditableArea = (target) => {
  if (!target || typeof target.closest !== "function") return false;
  return target.closest(EDITOR_SELECTORS);
};

// ---------- Page block karne wala helper ----------
const blockPage = () => {
  document.body.innerHTML =
    "<h2 style='text-align:center;margin-top:20%;font-family:sans-serif;'>Developer Tools is not allowed</h2>";
};

// ---------- Main hook: App.js me ek baar call karo ----------
const useDisableDevTools = () => {
  useEffect(() => {
    const isProd = process.env.REACT_APP_NODE_ENV === "production";
    if (!isProd) return; // dev me kuch bhi disable nahi

    // 1. Right-click disable (editor ke andar allow)
    const handleContextMenu = (e) => {
      if (isInsideEditableArea(e.target)) return;
      e.preventDefault();
    };

    // 2. Keyboard shortcuts disable (editor ke andar allow)
    const handleKeyDown = (e) => {
      if (isInsideEditableArea(e.target)) return;

      if (e.key === "F12" || e.keyCode === 123) e.preventDefault();

      if (
        e.ctrlKey &&
        e.shiftKey &&
        ["I", "i", "J", "j", "C", "c"].includes(e.key)
      ) {
        e.preventDefault();
      }
      if (
        e.metaKey &&
        e.altKey &&
        ["I", "i", "J", "j", "C", "c"].includes(e.key)
      ) {
        e.preventDefault();
      }
      if ((e.ctrlKey || e.metaKey) && (e.key === "U" || e.key === "u")) {
        e.preventDefault();
      }
      if ((e.ctrlKey || e.metaKey) && (e.key === "S" || e.key === "s")) {
        e.preventDefault();
      }
    };

    // 3. Text selection disable (editor ke andar allow)
    const handleSelectStart = (e) => {
      if (isInsideEditableArea(e.target)) return;
      e.preventDefault();
    };

    // 4. Window resize hone pe bhi check karte raho
    const checkWindowSize = () => {
      if (isDevToolsOpen()) blockPage();
    };

    // 5. console.log getter trick
    const element = new Image();
    Object.defineProperty(element, "id", {
      get: function () {
        blockPage();
        return "";
      },
    });

    const checkConsole = () => {
      console.log(element);
      console.clear();
    };

    // 6. Periodic combined check
    const checkAll = () => {
      if (isDevToolsOpen()) blockPage();
    };

    // ---------- Listeners attach ----------
    document.addEventListener("contextmenu", handleContextMenu);
    document.addEventListener("keydown", handleKeyDown);
    document.addEventListener("selectstart", handleSelectStart);
    window.addEventListener("resize", checkWindowSize);

    const checkInterval = setInterval(checkAll, 1000);
    const consoleInterval = setInterval(checkConsole, 1000);

    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("selectstart", handleSelectStart);
      window.removeEventListener("resize", checkWindowSize);
      clearInterval(checkInterval);
      clearInterval(consoleInterval);
    };
  }, []);
};

export default useDisableDevTools;